export default {
	styleOverrides: {
		root: {
			'& .MuiTab-root': {
				color: '#000000',
				'&.Mui-selected': {
					color: '#000000'
				}
			},
			'& .MuiTabs-indicator': {
				backgroundColor: '#000000'
			}
		}
	}
};
